import * as Types from './generalActionTypes.js'

const initialState = {
    timers: [],
    silos: [],
    breakdownDetectedDialogOpen: false,
    stoppedLine: null,
    notificationsCounter: 0,
    helpFilesDialogOpen: false,
    scaleData: null,
    systemParameters: []
};

export default function general(state = initialState, action) {
    switch (action.type) {
        case Types.SET_TIMERS:
            if (state.timers !== action.timers) {
                return Object.assign({}, state, { timers: action.timers });
            }
            return state;
        case Types.SET_SILOS:
            if (state.silos !== action.silos) {
                return Object.assign({}, state, { silos: action.silos });
            }
            return state;
        case Types.SET_BREAKDOWNDETECTEDDIALOGOPEN:
            if (state.breakdownDetectedDialogOpen !== action.breakdownDetectedDialogOpen) {
                return Object.assign({}, state, { breakdownDetectedDialogOpen: action.breakdownDetectedDialogOpen });
            }
            return state;
        case Types.SET_STOPPEDLINE:
            if (state.stoppedLine !== action.stoppedLine) {
                return Object.assign({}, state, { stoppedLine: action.stoppedLine });
            }
            return state;
        case Types.SET_COUNTER:
            if (state.notificationsCounter !== action.notificationsCounter) {
                return Object.assign({}, state, { notificationsCounter: action.notificationsCounter });
            }
            return state;
        case Types.SET_HELPFILESDIALOGOPEN:
            if (state.helpFilesDialogOpen !== action.helpFilesDialogOpen) {
                return Object.assign({}, state, { helpFilesDialogOpen: action.helpFilesDialogOpen });
            }
            return state;
        case Types.SET_SCALEDATA:
            if (state.scaleData !== action.scaleData) {
                return Object.assign({}, state, { scaleData: action.scaleData });
            }
            return state;
        case Types.SET_SYSTEMPARAMETERS:
            if (state.systemParameters !== action.systemParameters) {
                return Object.assign({}, state, { systemParameters: action.systemParameters });
            }
            return state;
        default:
            return state;
    }
}